module.exports = __webpack_public_path__ + "static/img/introduceContent1.0cf98da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduceContent1.png
// module id = uSkT
// module chunks = 0